var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 112 112"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 56,
  cy: 56,
  r: 56,
  fill: "#000",
  fillOpacity: 0.44
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M79.724 51.042c3.495 2.381 3.495 7.535 0 9.916L50.63 80.786c-3.983 2.714-9.379-.139-9.379-4.959V36.173c0-4.82 5.396-7.673 9.379-4.959z"
})));
export default SvgPlay;